import Directory from "./Directory";
import FileTreeNode from "./FileTreeNode";

export default class FileTree {
    constructor() {
        this._root = new FileTreeNode();
    }

    get root() {
        return this._root;
    }

    /**
     * Create new nodes to ensure the existence of the given path in the file tree.
     * @param {Array<String>} path 
     * @param {FileTreeNode} startNode
     * @returns {Boolean} Whether it had to create new nodes to ensure existence
     */
    ensurePathExists(path, startNode = this.root) {
        const nextPathPart = path.shift().trim();

        for (let i = 0; i < startNode.children.length; i++) {
            const node = startNode.children[i];
            if (!(node.data instanceof Directory)) {
                continue;
            }

            /** @type {Directory} */
            const directory = node.data;
            if (directory.getName() === nextPathPart) {
                if (path.length === 0) {
                    return true;
                }

                return this.ensurePathExists(path, node);
            }
        }

        // Create the nodes.
        // No need to search any more, we can just add the whole branch as the next nodes won't exist either.
        let previousNode = new FileTreeNode();
        previousNode.data = new Directory(nextPathPart);
        startNode.addChild(previousNode);

        for (let i = 0; i < path.length; i++) {
            const newNode = new FileTreeNode();
            newNode.data = new Directory(path[i]);

            previousNode.addChild(newNode);
            previousNode = newNode;
        }

        return false;
    }

    /**
     * Checks if path exists in file tree
     * @param {Array<String>} path 
     * @param {FileTreeNode} startNode
     * @returns {Boolean}
     */
    pathExists(path, startNode = this.root) {
        const nextPathPart = path.shift().trim();

        for (let i = 0; i < startNode.children.length; i++) {
            const node = startNode.children[i];
            if (!(node.data instanceof Directory)) {
                continue;
            }

            /** @type {Directory} */
            const directory = node.data;
            if (directory.getName() === nextPathPart) {
                if (path.length === 0) {
                    return true;
                }

                return this.pathExists(path, node);
            }
        }

        return false;
    }

    /**
     * Checks if path exists in file tree
     * @param {Array<String>} path 
     * @param {FileTreeNode} startNode 
     * @param {Boolean} ensurePathExists
     * @returns {FileTreeNode}
     */
    getNodeAtPath(path, ensurePathExists = false, startNode = this.root) {
        const nextPathPart = path.shift().trim();

        if (nextPathPart === "") {
            return startNode;
        }

        for (let i = 0; i < startNode.children.length; i++) {
            const node = startNode.children[i];
            if (!(node.data instanceof Directory)) {
                continue;
            }

            /** @type {Directory} */
            const directory = node.data;
            if (directory.getName() === nextPathPart) {
                if (path.length === 0) {
                    return node;
                }

                return this.getNodeAtPath(path, ensurePathExists, node);
            }
        }

        if (ensurePathExists) {
            // Create the nodes.
            // No need to search any more, we can just add the whole branch as the next nodes won't exist either.
            let previousNode = new FileTreeNode();
            previousNode.data = new Directory(nextPathPart);
            startNode.addChild(previousNode);

            for (let i = 0; i < path.length; i++) {
                const newNode = new FileTreeNode();
                newNode.data = new Directory(path[i]);

                previousNode.addChild(newNode);
                previousNode = newNode;
            }

            return previousNode;
        }

        return null;
    }
}